import { hasDiscoveryFeatureEntitlement, useDiscoveryFeatureEntitled } from './discoveryEntitlement';

export const CODE_CROSSWALK_FEATURE_KEY = 'code-crosswalk';

export const hasCodeCrosswalkEntitlement = (permissions) =>
  hasDiscoveryFeatureEntitlement(permissions, CODE_CROSSWALK_FEATURE_KEY);

export const useCodeCrosswalkEntitled = () => useDiscoveryFeatureEntitled(CODE_CROSSWALK_FEATURE_KEY);
